import { Campaign } from 'entities/campaign';
import { Selectors as Router } from 'router';
import { Client } from 'services/apiGatewayClient';
import { createService } from 'services/genericAPIGatewayService';
import { State } from 'store';
import { mapMpsCampaignResponseToEntity } from '../adapters';
import { MpsCampaignResponse } from '../types';
import { Service } from './services';

export const client = new Client<Campaign, Campaign, MpsCampaignResponse, MpsCampaignResponse[]>({
  mapToRequest: (x: Campaign) => x,
  mapFromResponse: mapMpsCampaignResponseToEntity,
  mapFromListResponse: (data: MpsCampaignResponse[]) =>
    Array.isArray(data) ? data.map(mapMpsCampaignResponseToEntity) : [],
});

const endpointCreator = (state: State) => {
  const siteId = Router.getSiteId(state);
  return !!siteId ? `/mps/sites/${siteId}/campaigns` : undefined;
};

export const { Actions, Selectors, Sagas } = createService<Campaign, Service.Campaigns>({
  service: Service.Campaigns,
  client,
  endpointCreator,
  stateConverter: (state: State) => state.campaigns.campaigns,
  sagas: ['GET', 'GET_COLLECTION', 'CREATE', 'DELETE', 'UPDATE', 'REDIRECT_AFTER_CREATE'],
  redirectAfterCreateUrl: (siteId: string, entityId: string) =>
    `/sites/${siteId}/campaigns/campaigns/${entityId}?showMessage=true`,
});
